export const SITE = {
  name: "Xpdustry",
  positioning: "Pretty cool Mindustry tools.",
  description:
    "We build open-source software for Mindustry, and also run the Chaotic Neutral Mindustry servers.",
  github: "https://github.com/xpdustry",
  discord: "https://discord.xpdustry.com",
  maven: "https://maven.xpdustry.com",
  email: "contact@xpdustry.com",
  origin: "https://xpdustry.com",
} as const;

export const BLOG_DESCRIPTION = "Release notes and technical deep dives.";

export const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/blog", label: "Blog" },
] as const;
